import { Title } from "@components/_Revamp/Typography/Title.stories";
import { styled } from "@linaria/react";
import Button from "@pages/EverGreen/Components/Button";
import MainContainer from "@pages/EverGreen/Components/Container";
import { trackOnLoad } from "@pages/EverGreen/Helpers/analyticsHelper";
import { useAvivaSelector } from "@redux/hook";
import { ROUTE_PATH } from "@static/route-paths";
import { SCREEN_SIZE } from "@static/screen-size";
import { EverGreenStyle } from "@utils/Style/everGreen";
import { Helpers } from "@utils/helpers";
import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";

function ViewQuotation() {
  const quotation = useAvivaSelector((state) => state.everGreenStep1.quotation);
  const productData = useAvivaSelector(
    (state) => state.everGreenStep1.staticData
  );
  const history = useHistory();

    //AA on load
    useEffect(()=>{
      if (quotation.sqsquotation.maturityPayout < 0) 
        return ;
      trackOnLoad()
    },[])

  if (quotation.sqsquotation.maturityPayout < 0) {
    history.push(ROUTE_PATH.EVER_GREEN_QUOTATION);
    return null;
  }
  return (
    <>
      <MainContainer
        backButtonPath={ROUTE_PATH.EVER_GREEN_QUOTATION}
        showFlowerPot={true}
        step={1}
      >
        <TitleContainer>
          <Title variant="title" align="center">
            Here&apos;s your quote
          </Title>
          <Title14
            style={{
              textAlign: "center",
              color: EverGreenStyle.colors.grey[1200],
            }}
          >
            Check your plan details before we start the application.
          </Title14>
        </TitleContainer>
        <ViewQuotationContainer>
          <section className="quoteheader">
            <div>Your Selection:</div>
            <section>
              <p>Single Premium</p>
              <p className="f600">
                {Helpers.toCurrency(Number(quotation.investingAmount))}
              </p>
            </section>
          </section>
          <section className="splitup">
            <h3>Plan Overview</h3>
            <div>
              <div>Plan Selected</div>
              <div className="f600">{productData.productName}</div>
            </div>
            <div>
              <div>Selected Amount</div>
              <div className="f600">
                {Helpers.toCurrency(Number(quotation.investingAmount))}
              </div>
            </div>
            <h3>Policy Value and Benefits Overview</h3>
            <div>
              <div className="surrender-container">
                <p>Cash Surrender Value</p>
                <div>
                  <ul className="sur-list">
                    {quotation.sqsquotation.surrenderValueList.map(
                      (list, i) => {
                        return (
                          <li key={`${i}-sur`}>
                            <span>Year {list.year} </span>
                            <span>{Helpers.toCurrency(list.amount)}</span>
                          </li>
                        );
                      }
                    )}
                  </ul>
                </div>
              </div>
            </div>
            <div>
              <div>Death Benefit</div>
              <div className="f600">
                {Helpers.toCurrency(quotation.sqsquotation.deathBenefit)}
              </div>
            </div>
            <div>
              <div>Maturity Benefit</div>
              <div className="f600">
                {Helpers.toCurrency(quotation.sqsquotation.maturityPayout)}
              </div>
            </div>
          </section>
        </ViewQuotationContainer>
        <ButtonContianer>
          <Button
            variant="default"
            label="Start my application"
            onClick={() => {
              history.push(ROUTE_PATH.EVER_GREEN_SINGPASS);
            }}
          />
        </ButtonContianer>
      </MainContainer>
    </>
  );
}

export default ViewQuotation;

const TitleContainer = styled.div`
  margin-bottom: 50px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  p:first-child {
    font-size: 24px;
    line-height: 33.6px;
  }
  @media screen and (min-width: ${SCREEN_SIZE.mobilesUp}px) {
    p:first-child {
      font-size: 28px;
      line-height: 39.2px;
    }
    p:nth-child(2) {
      font-size: 14px;
    }
  }
`;

const Title14 = styled.p`
  font-size: 14px;
  font-weight: 600;
  display: flex;
  justify-items: center;
  align-items: center;
  gap: 8px;
`;

const ViewQuotationContainer = styled.div`
  background-color: white;
  overflow: hidden;
  border-radius: 16px;
  width: 100%;
  max-width: 588px;
  font-size: 14px;
  margin: 0 auto;
  letter-spacing: 0.42px;
  line-height: 39.2px;
  .f600 {
    font-weight: 600;
  }
  & > section {
    color: ${EverGreenStyle.colors.grey[1400]};
    padding: 24px;
    h3 {
      color: ${EverGreenStyle.colors.primary};
      font-size: 18px;
      font-weight: 600;
    }
  }
  .sur-list > li {
    color: ${EverGreenStyle.colors.grey[1400]};
    span:nth-child(2) {
      float: right;
      font-weight: 600;
    }
  }
  .splitup {
    & > div {
      display: flex;
      padding-bottom: 0px;
      justify-content: space-between;
      width: 100%;
    }

    .surrender-container {
      width: 100%;
      ul {
        padding-left: 30px;
        li{
          padding-bottom: 0px;
        }
        li:last-child{
          padding-bottom: 0px;
        }
      }
    }

    @media screen and (min-width: ${SCREEN_SIZE.mobilesUp}px) {
      & > div {
      padding-bottom: 16px;
    }
      .surrender-container {
      width: 100%;
      ul {
        padding-left: 30px;
        li{
          padding-bottom: 16px;
        }
        li:last-child{
          padding-bottom: 0px;
        }
      }
    }
    }

  }
  .quoteheader {
    background-color: ${EverGreenStyle.colors.primary};
    color: ${EverGreenStyle.colors.white};
    padding: 24px;
    div:first-child {
      font-size: 16px;
      font-weight: 600;
      line-height: 25.2px;
      color: #ffffff;
    }
    section {
      display: flex;
      font-size: 28px;
      font-weight: 600;
      justify-content: space-between;
      line-height: 39.2px;

      p {
        font-size: 18px;
        letter-spacing: 0.27px;
      }
    }
  }
  @media screen and (min-width: ${SCREEN_SIZE.mobilesUp}px) {
    .splitup {
    & > div {
      padding-bottom: unset;
    }
    &>div:nth-child(3){
      margin-bottom: 40px;
    }

    .surrender-container {
      ul {
        li{
          padding-bottom: unset;
        }
      }
    }
  }
    .quoteheader {
      div:first-child {
        font-size: 18px;
        margin-bottom: 8px;
      }
      section {
        p {
          font-size: 28px;
        }
      }
    }
  }
`;

const ButtonContianer = styled.div`
  margin: auto;
  margin-top: 50px;
  width: 100%;
  max-width: 233px;
`;
